import { lazy, Suspense } from 'react';
import LoadingCom from '../../components/LoadingCom';
import PageErrorBoundary from '../../components/PageErrorBoundary';

const Support = lazy(() => import(/* webpackPrefetch: true */ './index'));

export default function SuspendedSupportDetail(props: any) {
  return (
    <PageErrorBoundary>
      <Suspense fallback={<LoadingCom />}>
        <Support {...props} />
      </Suspense>
    </PageErrorBoundary>
  );
}
